import {ajax as Ajax, Loc, Dom} from 'main.core';
import {EventEmitter} from 'main.core.events';
import {MessageBox} from 'ui.dialogs.messagebox';
import {Core} from 'im.v2.application.core';
import {ChatType, EventType} from 'im.v2.const';
import {MessageMenuManager, TaskCommentsMessageMenu} from 'im.v2.lib.menu';

import {getFullCardTaskCommentsMenuMethods, subClassEs6} from './task-full-card-message-menu';

export class Tasks {

    static checkTasksColor = false;
    static taskGetUrl = '/bitrix/services/main/ajax.php?action=tasks.v2.Task.get';
    static hideCommentContextMenuInited = false;
    static commentGroupIds = new Set();
    static taskGroupById = new Map();
    static taskGroupResolvedById = new Set();
    static taskGroupRequestById = new Map();
    static dialogTaskById = new Map();
    static taskCommentsMenuRegistered = false;
    static historyGridContextTaskId = 0;
    static historyGridDeleteLabel = '';
    static historyGridEnrichmentAttached = false;
    static historyGridAjaxTimer = null;
    static taskResultMenuObserver = null;
    static taskResultMenuTimer = null;
    static taskResultMenuContextTaskId = 0;

    static initHideCommentContextMenuItems(params = {}) {
        Tasks.commentGroupIds = new Set((Array.isArray(params.groupIds) ? params.groupIds : [])
            .map((groupId) => parseInt(groupId, 10))
            .filter((groupId) => groupId > 0));

        if (Tasks.commentGroupIds.size === 0) {
            return;
        }

        if (!Tasks.hideCommentContextMenuInited) {
            Tasks.hideCommentContextMenuInited = true;
            Tasks.bindLegacyCommentContextMenu();
            Tasks.bindTaskCommentsMessageMenu();

            BX.addCustomEvent('onAjaxSuccess', Tasks.onTaskAjaxSuccess);
            BX.addCustomEvent('SidePanel.Slider:onLoad', Tasks.onTaskSliderLoad);
            if (EventEmitter?.subscribe && EventType?.dialog?.onDialogInited) {
                EventEmitter.subscribe(EventType.dialog.onDialogInited, Tasks.onTaskCommentsDialogInited);
            }
        }

        Tasks.rememberInitialTaskGroups(params.taskGroups);
        Tasks.initHideTaskResultMenu();
        Tasks.preloadTaskFromUrl(window.location.href);
        Tasks.preloadCurrentTaskCommentsDialog();
    }

    static hideCommentContextMenuItems() {
        Tasks.initHideCommentContextMenuItems({groupIds: Array.from(Tasks.commentGroupIds)});
    }

    static bindLegacyCommentContextMenu() {
        BX.addCustomEvent('OnUCCommentActionsShown', function(container, messageId, menuItems){
            if (!Tasks.isAllowedTaskSync(Tasks.resolveTaskIdFromUrl(window.location.href), window.location.href)) {
                return;
            }

            Tasks.removeLegacyCommentMenuItems(menuItems);
        });
    }

    static bindTaskCommentsMessageMenu() {
        if (Tasks.taskCommentsMenuRegistered) {
            return;
        }

        if (!MessageMenuManager?.getInstance || !TaskCommentsMessageMenu) {
            return;
        }

        Tasks.taskCommentsMenuRegistered = true;
        MessageMenuManager.getInstance().registerMenuByCallback((context) => {
            if (!Tasks.isTaskCommentsDialog(context?.dialogId)) {
                return false;
            }

            const taskUrl = Tasks.resolveTaskUrlFromDialog(context.dialogId);
            const taskId = Tasks.resolveTaskIdFromDialog(context.dialogId) || Tasks.resolveTaskIdFromUrl(taskUrl);
            if (taskId > 0) {
                Tasks.dialogTaskById.set(context.dialogId, taskId);
            }

            return Tasks.isAllowedTaskSync(taskId, taskUrl);
        }, RestrictedTaskCommentsMessageMenu);
    }

    static removeLegacyCommentMenuItems(menuItems) {
        if (!Array.isArray(menuItems)) {
            return;
        }

        const blockedTexts = new Set([
            BX.message('BPC_MES_DELETE'),
            BX.message('BPC_MES_EDIT'),
        ]);

            for (let i = menuItems.length - 1; i >= 0; i--) {
            if (menuItems[i]?.text && blockedTexts.has(menuItems[i].text)) {
                    menuItems.splice(i, 1);
                }
            }
    }

    static initHideTaskResultMenu() {
        Tasks.hideTaskResultMenus();

        if (Tasks.taskResultMenuObserver || !document.body) {
            return;
        }

        Tasks.taskResultMenuObserver = new MutationObserver(() => {
            clearTimeout(Tasks.taskResultMenuTimer);
            Tasks.taskResultMenuTimer = setTimeout(() => {
                Tasks.hideTaskResultMenus();
            }, 50);
        });

        Tasks.taskResultMenuObserver.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    static hideTaskResultMenus() {
        document.querySelectorAll('.tasks-field-results[data-task-id]').forEach((container) => {
            const taskId = parseInt(container?.dataset?.taskId, 10) || 0;
            if (taskId > 0) {
                Tasks.taskResultMenuContextTaskId = taskId;
            }
            Tasks.toggleTaskResultMenuIcons(container, Tasks.isAllowedTaskSync(taskId, window.location.href));
        });

        document.querySelectorAll('.tasks-field-results-result[data-task-field-id="results"], .tasks-field-results-result.--list-mode').forEach((result) => {
            if (result.closest('.tasks-field-results[data-task-id]')) {
                return;
            }

            const taskId = Tasks.resolveTaskIdForResultMenu(result);
            Tasks.toggleTaskResultMenuIcons(result, Tasks.isAllowedTaskSync(taskId, window.location.href));
        });
    }

    static resolveTaskIdForResultMenu(result) {
        const containerTaskId = parseInt(result?.closest?.('.tasks-field-results[data-task-id]')?.dataset?.taskId, 10) || 0;
        if (containerTaskId > 0) {
            return containerTaskId;
        }

        const urlTaskId = Tasks.resolveTaskIdFromUrl(window.location.href);
        if (urlTaskId > 0) {
            return urlTaskId;
        }

        const topSliderUrl = BX?.SidePanel?.Instance?.getTopSlider?.()?.getUrl?.() || '';
        const sliderTaskId = Tasks.resolveTaskIdFromUrl(topSliderUrl);
        if (sliderTaskId > 0) {
            return sliderTaskId;
        }

        return Tasks.taskResultMenuContextTaskId;
    }

    static toggleTaskResultMenuIcons(root, shouldHide) {
        if (!root) {
            return;
        }

        root.querySelectorAll('.tasks-field-results-result .tasks-field-results-title-actions .tasks-field-results-title-icon[class~="--more-l"]').forEach((icon) => {
            if (shouldHide) {
                if (!icon.dataset.brHtstechOriginalDisplay) {
                    icon.dataset.brHtstechOriginalDisplay = icon.style.display || ' ';
                }
                icon.style.display = 'none';
            } else if (icon.dataset.brHtstechOriginalDisplay) {
                icon.style.display = icon.dataset.brHtstechOriginalDisplay === ' ' ? '' : icon.dataset.brHtstechOriginalDisplay;
                delete icon.dataset.brHtstechOriginalDisplay;
            }
        });
    }

    //Checked status
    /**
     * copy local/aac_script.js  clickstage462
     */
    static clickStage(clickStageId) {
        let statusFind = false;
        document.querySelectorAll('#tasksStages div').forEach(function (div) {
            const stageId = parseInt(div?.dataset?.stageid, 10);
            if (stageId === clickStageId) {
                statusFind = true;
                BX.fireEvent(div, 'click')
            }

        })
        if (!statusFind) {
            MessageBox.alert(Loc.getMessage('BR_HTSTECH_TASK_STATUS_NOT_FOUND', {'#ID#': clickStageId}));
        }

    }

    /**
     * copy local/aac_script.js  startbiz14
     */

    static startBiz(tasksId) {
        Ajax.runAction('bestrank:htstech.Tasks.startStopBp', {
            data: {tasksId: tasksId}
        }).then((response) => {
            window.location.reload();
        }, function (reason) {
            let message = '';
            for (let error in reason.errors) {
                message += reason.errors[error].message + '<br/>'
            }
            MessageBox.alert(message);
        });
    }

    static addTasksColor(checkStageId) {
        if(!Tasks.checkTasksColor)
        BX.addCustomEvent("Kanban.Grid:addItem", BX.delegate(function (command) {
                const stageId = parseInt(command?.data?.stage_id,10)
                if(stageId===checkStageId)
                    setTimeout(() => {
                        Ajax.runAction('bestrank:htstech.Tasks.getColorTaskStage', {
                            data: {taskId: command.id}
                        }).then((data) => {
                            const json = data.data
                            //console.error('test json',json)
                            if (json.COLOR != "") {
                                Dom.style(command.container, "background-color", json.COLOR);
                            }
                            if (json.UF_LIST != "") {
                                if (json.UF_LIST != "" && command.container) {
                                    const taskTitleElement = command.container.querySelector(`.tasks-kanban-item-title`);
                                    if (taskTitleElement) {
                                        const textNode = `${Loc.getMessage('BR_HTSTECH_TASK_MANUFACTURER')}: ${json.UF_LIST}`;
                                        taskTitleElement.insertAdjacentHTML('afterend', textNode);
                                    }
                                }
                            }
                        }, function (reason) {
                            let message = '';
                            for (let error in reason.errors) {
                                message += reason.errors[error].message + '<br/>'
                            }
                            MessageBox.alert(message);
                        });
                    }, 100);
                }
            )
        )
        Tasks.checkTasksColor = true;
    }

    /**
     * @param {function} callback
     */
    static ensureTasksExtension(callback) {
        if (typeof callback !== 'function') {
            return;
        }

        if (BX?.Bestrank?.HTSTech?.Tasks) {
            callback();

            return;
        }

        if (BX?.Runtime?.loadExtension) {
            BX.Runtime.loadExtension('bestrank.htstech.tasks').then(() => {
                if (BX?.Bestrank?.HTSTech?.Tasks) {
                    callback();
                }
            });
        }
    }

    /**
     * Bind task id for history grid enrichment (SPA navigation + full page).
     *
     * @param {number} taskId Task ID
     */
    static bindHistoryGridForTask(taskId) {
        const id = parseInt(taskId, 10) || 0;
        if (id <= 0) {
            return;
        }

        Tasks.ensureHistoryGridCommentEnrichment();
        Tasks.setHistoryGridDetailContext(id);

        const container = Tasks.getHistoryGridContainer();
        if (container) {
            Tasks.scheduleHistoryGridCommentDetailFetch(id, container);
        }
    }

    /**
     * Load and display comment changes (classic log table + tasks.v2 history grid in slider).
     * 
     * @param {number} taskId Task ID
     */
    static loadCommentChanges(taskId) {
        Tasks.ensureTasksExtension(() => {
            Tasks.bindHistoryGridForTask(taskId);
            Tasks.loadLegacyTableCommentChanges(taskId);
        });
    }

    /**
     * Legacy markup: .task-log-table on task view.
     *
     * @param {number} taskId Task ID
     */
    static loadLegacyTableCommentChanges(taskId) {
        const logData = [];
        
        document.querySelectorAll('.task-log-table tbody tr').forEach((row, index) => {
            const date = row.querySelector('.task-log-date')?.textContent?.trim();
            const authorLink = row.querySelector('.task-log-author-column a[href]');
            const commentLink = row.querySelector('.task-log-where-column a[href*="MID="]');
            
            if (date && authorLink && commentLink) {
                const userId = Tasks.extractUserIdFromHref(authorLink.href);
                const commentId = Tasks.extractCommentIdFromHref(commentLink.href);
                
                logData.push({
                    rowIndex: index,
                    date: date,
                    userId: userId,
                    toValue: commentId ?? '',
                });
            }
        });
        
        if (logData.length === 0) {
            return;
        }
        
        Ajax.runAction('bestrank:htstech.Tasks.getCommentChanges', {
            data: {
                taskId: taskId,
                logData: logData
            }
        }).then((response) => {
            Tasks.updateCommentChanges(response.data);
        }, function (reason) {
            console.warn('Failed to load comment changes:', reason);
        });
    }

    static ensureHistoryGridCommentEnrichment() {
        if (Tasks.historyGridEnrichmentAttached) {
            return;
        }
        Tasks.historyGridEnrichmentAttached = true;
        if (EventEmitter?.subscribe) {
            EventEmitter.subscribe('Grid::updated', Tasks.onTasksHistoryGridUpdated);
        }
        BX.addCustomEvent('onAjaxSuccess', Tasks.onHistoryGridAjaxSuccess);
        BX.addCustomEvent('SidePanel.Slider:onLoad', Tasks.onSidePanelSliderLoad);
    }

    /**
     * @param {*} event SidePanel slider event
     */
    static onSidePanelSliderLoad(event) {
        Tasks.ensureTasksExtension(() => {
            const slider = event?.getSlider?.() || event?.getTarget?.() || null;
            const sliderUrl = String(slider?.getUrl?.() || '');

            if (sliderUrl.includes('tasks-history-grid')) {
                const taskId = Tasks.historyGridContextTaskId;
                if (taskId > 0) {
                    Tasks.scheduleHistoryGridCommentDetailFetch(taskId);
                }

                return;
            }

            const taskId = Tasks.resolveTaskIdFromUrl(sliderUrl);
            if (taskId > 0) {
                Tasks.bindHistoryGridForTask(taskId);
            }
        });
    }

    /**
     * @param {*} event BX Main EventEmitter payload
     */
    static onTasksHistoryGridUpdated(event) {
        const taskId = Tasks.historyGridContextTaskId;
        if (!taskId) {
            return;
        }

        const compat =
            typeof event?.getCompatData === 'function'
                ? event.getCompatData()
                : (event?.compatData ?? null);
        const grid = Array.isArray(compat) ? compat[0] : null;
        if (!grid || typeof grid.getId !== 'function' || grid.getId() !== 'tasks-history-grid') {
            return;
        }

        const container =
            typeof grid.getContainer === 'function' ? grid.getContainer() : null;
        if (!container) {
            return;
        }

        clearTimeout(Tasks.historyGridAjaxTimer);
        Tasks.scheduleHistoryGridCommentDetailFetch(taskId, container);
    }

    static onHistoryGridAjaxSuccess() {
        const taskId = Tasks.historyGridContextTaskId;
        if (!taskId || !Tasks.isHistoryGridAjaxEvent(arguments)) {
            return;
        }

        Tasks.scheduleHistoryGridCommentDetailFetch(taskId);
    }

    static isHistoryGridAjaxEvent(args) {
        const url = Tasks.resolveUrlFromEventArgs(args);
        if (
            url
            && (
                Tasks.normalizeUrl(url).includes('action=tasks.v2.Task.HistoryGrid.get')
                || Tasks.normalizeUrl(url).includes('action=tasks.v2.Task.HistoryGrid.getData')
            )
        ) {
            return true;
        }

        for (let i = 0; i < args.length; i++) {
            const arg = args[i];
            if (arg && typeof arg === 'object') {
                const action = arg.action || arg.ACTION || arg.data?.action || arg.data?.ACTION;
                if (
                    action === 'tasks.v2.Task.HistoryGrid.get'
                    || action === 'tasks.v2.Task.HistoryGrid.getData'
                ) {
                    return true;
                }
            }
        }

        return false;
    }

    static scheduleHistoryGridCommentDetailFetch(taskId, gridContainer = null) {
        clearTimeout(Tasks.historyGridAjaxTimer);
        Tasks.historyGridAjaxTimer = setTimeout(() => {
            const container = gridContainer || Tasks.getHistoryGridContainer();
            if (container) {
                Tasks.runHistoryGridCommentDetailFetch(taskId, container);
            }
        }, 180);
    }

    static getHistoryGridContainer() {
        const gridManager = BX?.Main?.gridManager;
        const grid = gridManager?.getById ? gridManager.getById('tasks-history-grid') : null;
        const instance = grid?.instance || grid;
        const container =
            typeof instance?.getContainer === 'function' ? instance.getContainer() : null;

        return container || document.getElementById('tasks-history-grid');
    }

    static setHistoryGridDetailContext(taskId) {
        const id = parseInt(taskId, 10) || 0;
        if (id > 0) {
            Tasks.historyGridContextTaskId = id;
        }
    }

    /**
     * @param {HTMLElement} gridContainer
     */
    static collectHistoryGridEditLogData(gridContainer) {
        const logData = [];
        const editLocations = new Set(['COMMENT_EDIT', 'RESULT_EDIT', 'RESULT']);

        gridContainer
            .querySelectorAll('tbody tr.main-grid-row-body[data-id], tbody tr[data-id]')
            .forEach((row) => {
            const location = row.querySelector('[data-changeset-location]')
                ?.dataset?.changesetLocation;
            if (!editLocations.has(location)) {
                return;
            }

            if (location === 'COMMENT_EDIT') {
            Tasks.removeHistoryGridCommentLinkClass(row);
            }

            if (Tasks.updateHistoryGridRowFromEmbeddedChange(row)) {
                return;
            }

            const authorNode = row.querySelector('[data-author-id]');
            const userId = authorNode?.dataset?.authorId;
            const tsNode = row.querySelector('[data-time]');
            const createdTs = tsNode?.dataset?.time ? parseInt(tsNode.dataset.time, 10) : 0;

            const valueNode = row.querySelector('[data-changeset-from-value]');

            let toValue = '';
            try {
                const parsedTo = Tasks.parseQuotedJsonDatasetValue(valueNode?.dataset?.changesetToValue);
                toValue = `${parsedTo}`;
            } catch (_e) {
                return;
            }

            const rowKey = row?.dataset?.id;
            if (!userId || !createdTs || !rowKey) {
                return;
            }

            logData.push({
                rowId: rowKey,
                userId: userId,
                createdTs: createdTs,
                toValue: toValue,
                field: location,
            });
        });

        return logData;
    }

    /**
     * @param {HTMLElement} gridContainer
     */
    static collectHistoryGridDeletedLogData(gridContainer) {
        const deletedData = [];

        gridContainer
            .querySelectorAll('tbody tr.main-grid-row-body[data-id], tbody tr[data-id]')
            .forEach((row) => {
            const location = row.querySelector('[data-changeset-location]')
                ?.dataset?.changesetLocation;
            if (location !== 'COMMENT_DEL' && location !== 'RESULT_REMOVE') {
                return;
            }

            if (location === 'COMMENT_DEL') {
                Tasks.removeHistoryGridCommentLinkClass(row);
            }

            const valueNode = row.querySelector('[data-changeset-from-value]');

            let entityId = '';
            try {
                const parsedDel = Tasks.parseQuotedJsonDatasetValue(valueNode?.dataset?.changesetToValue);
                entityId = `${parsedDel}`;
            } catch (_e) {
                return;
            }

            const rowKey = row?.dataset?.id;
            if (!entityId || !rowKey) {
                return;
            }

            const cleanId = entityId.replace(/^#/, '');
            if (location === 'RESULT_REMOVE') {
                deletedData.push({
                    rowId: rowKey,
                    resultId: cleanId,
                    field: 'RESULT_REMOVE',
                });
            } else {
            deletedData.push({
                rowId: rowKey,
                    commentId: cleanId,
                    field: 'COMMENT_DEL',
            });
            }
        });

        return deletedData;
    }

    /**
     * @param {string|undefined|null} raw
     * @returns {string}
     */
    static parseQuotedJsonDatasetValue(raw) {
        if (raw === undefined || raw === null || raw === '') {
            throw new Error('empty dataset');
        }

        const parsed = JSON.parse(raw);

        return parsed !== null && parsed !== undefined ? String(parsed) : '';
    }

    static updateHistoryGridRowFromEmbeddedChange(row) {
        const valueHost = row?.querySelector('[data-changeset-from-value]');
        if (!valueHost || valueHost.dataset.htstechDetailsLoaded === 'Y') {
            return false;
        }

        const change = Tasks.parseCommentChangeFromDatasetValue(valueHost.dataset.changesetFromValue);
        if (!change || change.before === null || change.after === null) {
            return false;
        }

        var el = BX.create('span', {
            html: '<span class="comment-change">' + Tasks.escapeHtml(change.before) + ' <span class="task-log-arrow">&rarr;</span> ' + Tasks.escapeHtml(change.after) + '</span>',
            props: {
                className: 'comment-change'
            },
        });
        BX.append(el,valueHost)
        valueHost.dataset.htstechDetailsLoaded = 'Y';

        return true;
    }

    static removeHistoryGridCommentLinkClass(row) {
        row?.querySelectorAll('[data-changeset-location] .tasks-history-grid-comment-link')
            ?.forEach((element) => {
                element.classList.remove('tasks-history-grid-comment-link');
            });
    }

    static parseCommentChangeFromDatasetValue(raw) {
        let serialized = '';
        try {
            serialized = Tasks.parseQuotedJsonDatasetValue(raw);
        } catch (_e) {
            return null;
        }

        const before = Tasks.extractPhpSerializedStringValue(serialized, 'before');
        const after = Tasks.extractPhpSerializedStringValue(serialized, 'after');
        if (before === null || after === null) {
            return null;
        }

        return {before: before, after: after};
    }

    static extractPhpSerializedStringValue(serialized, key) {
        const escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const pattern = new RegExp(`s:\\d+:"${escapedKey}";s:(\\d+):"`);
        const match = pattern.exec(serialized);
        if (!match) {
            return null;
        }

        const byteLength = parseInt(match[1], 10);
        if (byteLength < 0) {
            return null;
        }

        let bytes = 0;
        let value = '';
        let index = match.index + match[0].length;
        while (index < serialized.length && bytes < byteLength) {
            const char = serialized.charAt(index);
            value += char;
            bytes += Tasks.getUtf8ByteLength(char);
            index++;
        }

        return bytes === byteLength && serialized.substr(index, 2) === '";' ? value : null;
    }

    static getUtf8ByteLength(value) {
        return unescape(encodeURIComponent(value)).length;
    }

    static runHistoryGridCommentDetailFetch(taskId, gridContainer) {
        Tasks.fetchHistoryGridCommentEdits(taskId, gridContainer);
        Tasks.fetchHistoryGridCommentDeletes(taskId, gridContainer);
    }

    static fetchHistoryGridCommentEdits(taskId, gridContainer) {
        const logData = Tasks.collectHistoryGridEditLogData(gridContainer);
        if (logData.length === 0) {
            return;
        }

        Ajax.runAction('bestrank:htstech.Tasks.getCommentChanges', {
            data: {
                taskId: taskId,
                logData: logData
            }
        }).then((response) => {
            Tasks.updateHistoryGridCommentChanges(gridContainer, response.data);
        }, function (reason) {
            console.warn('Failed to load history grid comment changes:', reason);
        });
    }

    static fetchHistoryGridCommentDeletes(taskId, gridContainer) {
        const deletedData = Tasks.collectHistoryGridDeletedLogData(gridContainer);
        if (deletedData.length === 0) {
            return;
        }

        Ajax.runAction('bestrank:htstech.Tasks.getCommentDeleted', {
            data: {
                taskId: taskId,
                deletedData: deletedData
            }
        }).then((response) => {
            Tasks.updateHistoryGridCommentDeletes(gridContainer, response.data);
        }, function (reason) {
            console.warn('Failed to load history grid deleted comments:', reason);
        });
    }

    static escapeHtml(text) {
        return String(text)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

    /**
     * @param {HTMLElement} gridContainer
     * @param {Array} changesData
     */
    static updateHistoryGridCommentChanges(gridContainer, changesData) {
        if (!gridContainer || !Array.isArray(changesData)) {
            return;
        }

        changesData.forEach(change => {
            if (
                typeof change?.before !== 'string'
                || typeof change?.after !== 'string'
                || !change.rowId
            ) {
                return;
            }

            if (!/^\d+$/.test(String(change.rowId))) {
                return;
            }

            const rowSelector = `tr[data-id="${change.rowId}"]`;
            const row = gridContainer.querySelector(rowSelector);
            const valueHost = row?.querySelector('[data-changeset-from-value]');
            if (!valueHost || valueHost.dataset.htstechDetailsLoaded === 'Y') {
                return;
            }

            var el = BX.create('span', {
                html: '<span class="comment-change">' + Tasks.escapeHtml(change.before) + ' <span class="task-log-arrow">&rarr;</span> ' + Tasks.escapeHtml(change.after) + '</span>',
                props: {
                    className: 'comment-change'
                },
            });
            BX.append(el,valueHost)
            valueHost.dataset.htstechDetailsLoaded = 'Y';
        });
    }

    /**
     * @param {HTMLElement} gridContainer
     * @param {Array} deletedResponse
     */
    static updateHistoryGridCommentDeletes(gridContainer, deletedResponse) {
        if (!gridContainer || !Array.isArray(deletedResponse)) {
            return;
        }

        deletedResponse.forEach(item => {
            if (!item?.before || !item.rowId) {
                return;
            }

            if (!/^\d+$/.test(String(item.rowId))) {
                return;
            }

            const rowSelector = `tr[data-id="${item.rowId}"]`;
            const row = gridContainer.querySelector(rowSelector);
            const valueHost = row?.querySelector('[data-changeset-from-value]');
            if (!valueHost || valueHost.dataset.htstechDetailsLoaded === 'Y') {
                return;
            }

            var el = BX.create('span', {
                html: '<span class="comment-deleted">' + Tasks.escapeHtml(item.before) + ' <span class="task-log-arrow">&rarr;</span> ' + Tasks.escapeHtml(item.after) + '</span>',
                props: {
                    className: 'comment-change'
                },
            });
            BX.append(el, valueHost);
            valueHost.dataset.htstechDetailsLoaded = 'Y';
        });
    }

    /**
     * Update interface with comment changes
     * 
     * @param {Array} changesData Array of change data
     */
    static updateCommentChanges(changesData) {
        if (!Array.isArray(changesData)) {
            return;
        }

        changesData.forEach(change => {
            if (change.rowId) {
                return;
            }

            const rows = document.querySelectorAll('.task-log-table tbody tr');
            const targetRow = rows[change.rowIndex];
            
            if (
                targetRow
                && typeof change.before === 'string'
                && typeof change.after === 'string'
            ) {
                const whatColumn = targetRow.querySelector('.task-log-what-column .task-log-what');
                if (whatColumn) {
                    whatColumn.innerHTML = `
                        <span class="comment-change">
                            ${Tasks.escapeHtml(change.before)} <span class="task-log-arrow">&rarr;</span> ${Tasks.escapeHtml(change.after)}
                        </span>
                    `;
                }
            }
        });
    }

    /**
     * Load and display deleted comment contents (legacy markup + history grid).
     * 
     * @param {number} taskId Task ID
     */
    static loadCommentDeleted(taskId, messDeleteComment) {
        Tasks.ensureHistoryGridCommentEnrichment();
        Tasks.historyGridDeleteLabel = typeof messDeleteComment === 'string' ? messDeleteComment : '';
        Tasks.setHistoryGridDetailContext(taskId);
        Tasks.loadLegacyTableCommentDeleted(taskId, messDeleteComment);
    }

    /**
     * @param {number} taskId Task ID
     */
    static loadLegacyTableCommentDeleted(taskId, messDeleteComment) {
        const deletedData = [];

        document.querySelectorAll('.task-log-table tbody tr').forEach((row, index) => {
            const whereCell = row.querySelector('.task-log-where-column .task-log-where');
            const text = whereCell?.textContent?.trim();
            if (!text) {
                return;
            }

            let match = null;
            if (messDeleteComment && typeof messDeleteComment === 'string') {
                const esc = messDeleteComment.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                const dynRe = new RegExp(esc + '\\s*#' + '(\\d+)', 'i');
                match = text.match(dynRe);
            }

            if (match) {
                deletedData.push({
                    rowIndex: index,
                    commentId: match[1]
                });
            }
        });

        if (deletedData.length === 0) {
            return;
        }

        Ajax.runAction('bestrank:htstech.Tasks.getCommentDeleted', {
            data: {
                taskId: taskId,
                deletedData: deletedData
            }
        }).then((response) => {
            Tasks.updateCommentDeleted(response.data);
        }, function (reason) {
            console.warn('Failed to load deleted comments:', reason);
        });
    }

    /**
     * Update interface with deleted comment original content — legacy rows only.

     * 
     * @param {Array} deletedResponse Array of objects: { rowIndex, before }
     */
    static updateCommentDeleted(deletedResponse) {
        if (!Array.isArray(deletedResponse)) {
            return;
        }

        deletedResponse.forEach(item => {
            if (item.rowId) {
                return;
            }

            const rows = document.querySelectorAll('.task-log-table tbody tr');
            const targetRow = rows[item.rowIndex];
            if (!targetRow || !item?.before) {
                return;
            }

            const whatContainer = targetRow.querySelector('.task-log-what-column .task-log-what');
            if (whatContainer) {
                whatContainer.innerHTML = `
                    <span class="comment-deleted">${Tasks.escapeHtml(item.before)}<span class="task-log-arrow">&rarr;</span></span>
                `;
            }
        });
    }

    static onTaskAjaxSuccess() {
        const url = Tasks.resolveUrlFromEventArgs(arguments);
        if (Tasks.normalizeUrl(url) !== Tasks.taskGetUrl) {
            return;
        }

        const taskData = Tasks.resolveTaskData(arguments[0]);
        Tasks.rememberTaskGroup(taskData);
    }

    static onTaskSliderLoad(event) {
        Tasks.ensureTasksExtension(() => {
            const slider = event?.getSlider?.() || event?.getTarget?.() || null;
            const sliderUrl = slider?.getUrl?.() || '';
            Tasks.preloadTaskFromUrl(sliderUrl);
        });
    }

    static onTaskCommentsDialogInited(event) {
        const data = event?.getData?.() || {};
        const dialogId = data.dialogId || '';
        if (Tasks.isTaskCommentsDialog(dialogId)) {
            Tasks.preloadTaskFromDialog(dialogId);
        }
    }

    static rememberInitialTaskGroups(taskGroups) {
        if (!taskGroups || typeof taskGroups !== 'object') {
            return;
        }

        Object.entries(taskGroups).forEach(([taskId, groupId]) => {
            const preparedTaskId = parseInt(taskId, 10) || 0;
            const preparedGroupId = parseInt(groupId, 10) || 0;
            if (preparedTaskId > 0 && preparedGroupId > 0) {
                Tasks.taskGroupById.set(preparedTaskId, preparedGroupId);
                Tasks.taskGroupResolvedById.add(preparedTaskId);
            }
        });
    }

    static preloadCurrentTaskCommentsDialog() {
        const dialogId = Core?.getStore?.()?.getters?.['application/getLayout']?.entityId || '';
        if (dialogId) {
            Tasks.preloadTaskFromDialog(dialogId);
        }
    }

    static preloadTaskFromDialog(dialogId) {
        const taskUrl = Tasks.resolveTaskUrlFromDialog(dialogId);
        const taskId = Tasks.resolveTaskIdFromDialog(dialogId) || Tasks.resolveTaskIdFromUrl(taskUrl);
        if (taskId <= 0) {
            return;
        }

        Tasks.dialogTaskById.set(dialogId, taskId);
        Tasks.preloadTaskFromUrl(taskUrl);
        Tasks.loadTaskGroup(taskId);
    }

    static preloadTaskFromUrl(url) {
        const taskId = Tasks.resolveTaskIdFromUrl(url);
        if (taskId <= 0) {
            return;
        }

        Tasks.bindHistoryGridForTask(taskId);

        if (Tasks.resolveGroupIdFromTaskUrl(url) > 0) {
            return;
        }

        Tasks.loadTaskGroup(taskId);
    }

    static isAllowedTaskSync(taskId, taskUrl = '') {
        const groupIdFromUrl = Tasks.resolveGroupIdFromTaskUrl(taskUrl);
        if (groupIdFromUrl > 0) {
            return Tasks.commentGroupIds.has(groupIdFromUrl);
        }

        if (taskId <= 0) {
            return false;
        }

        if (!Tasks.taskGroupResolvedById.has(taskId)) {
            Tasks.tryRememberTaskGroupFromTasksV2Store(taskId);
        }

        if (Tasks.taskGroupResolvedById.has(taskId)) {
            const groupIdFromCache = Tasks.taskGroupById.get(taskId) || 0;
            return Tasks.commentGroupIds.has(groupIdFromCache);
        }

        Tasks.loadTaskGroup(taskId);
        return false;
    }

    static loadTaskGroup(taskId) {
        const preparedTaskId = parseInt(taskId, 10) || 0;
        if (preparedTaskId <= 0 || Tasks.taskGroupResolvedById.has(preparedTaskId)) {
            return null;
        }

        if (Tasks.tryRememberTaskGroupFromTasksV2Store(preparedTaskId)) {
            return null;
        }

        if (Tasks.taskGroupRequestById.has(preparedTaskId)) {
            return Tasks.taskGroupRequestById.get(preparedTaskId);
        }

        const request = Ajax.runAction('tasks.v2.Task.get', {
            json: {
                method: 'GET',
                taskId: preparedTaskId
            }
        }).then((response) => {
            Tasks.rememberTaskGroup(Tasks.resolveTaskData(response), preparedTaskId);
            Tasks.taskGroupRequestById.delete(preparedTaskId);
        }, (reason) => {
            console.warn('Failed to load task group:', reason);
            Tasks.taskGroupById.set(preparedTaskId, 0);
            Tasks.taskGroupResolvedById.add(preparedTaskId);
            Tasks.taskGroupRequestById.delete(preparedTaskId);
        });

        Tasks.taskGroupRequestById.set(preparedTaskId, request);
        return request;
    }

    static rememberTaskGroup(taskData, fallbackTaskId = 0) {
        const taskId = parseInt(taskData?.id || taskData?.ID || taskData?.taskId || taskData?.TASK_ID || fallbackTaskId, 10) || 0;
        if (taskId <= 0) {
            return;
        }

        const groupId = Tasks.extractGroupIdFromTaskLike(taskData);
            Tasks.taskGroupById.set(taskId, groupId);
            Tasks.taskGroupResolvedById.add(taskId);
            Tasks.hideTaskResultMenus();
        }

    /**
     * Task payload shapes: AJAX tasks.v2, PHP-backed maps, tasks.vuex store task model.
     */
    static extractGroupIdFromTaskLike(taskData) {
        if (!taskData || typeof taskData !== 'object') {
            return 0;
        }

        let groupId = Tasks.resolveGroupId(taskData.group ?? taskData.groupId ?? taskData.GROUP_ID);
        if (groupId === 0 && taskData.group && typeof taskData.group === 'object') {
            groupId = Tasks.resolveGroupId(taskData.group.id ?? taskData.group.ID);
        }

        return groupId;
    }

    static peekTasksV2StoreTask(taskId) {
        const id = parseInt(taskId, 10) || 0;
        if (id <= 0 || typeof BX === 'undefined') {
            return null;
        }

        const core = BX.Tasks?.V2?.Core;
        const store = core?.getStore?.();
        const getById = store?.getters?.['tasks/getById'];
        if (typeof getById !== 'function') {
            return null;
        }

        const task = getById(id);
        return task || null;
    }

    static tryRememberTaskGroupFromTasksV2Store(taskId) {
        const task = Tasks.peekTasksV2StoreTask(taskId);
        if (!task) {
            return false;
        }

        Tasks.rememberTaskGroup(task, taskId);
        return true;
    }

    static resolveTaskData(response) {
        const data = response?.data || response || {};
        return data.task || data.TASK || data;
    }

    static resolveGroupId(group) {
        if (typeof group === 'number' || typeof group === 'string') {
            return parseInt(group, 10) || 0;
        }

        if (group && typeof group === 'object') {
            return parseInt(group.id || group.ID, 10) || 0;
        }

        return 0;
    }

    static isTaskCommentsDialog(dialogId) {
        const chat = Tasks.getChatByDialogId(dialogId);
        return chat?.type === ChatType?.taskComments;
    }

    static getChatByDialogId(dialogId) {
        if (!dialogId) {
            return null;
        }

        return Core?.getStore?.()?.getters?.['chats/get']?.(dialogId, true) || null;
    }

    static resolveTaskIdFromDialog(dialogId) {
        if (Tasks.dialogTaskById.has(dialogId)) {
            return Tasks.dialogTaskById.get(dialogId);
        }

        const chat = Tasks.getChatByDialogId(dialogId);
        const entityId = parseInt(chat?.entityLink?.id, 10) || 0;
        if (entityId > 0 && String(chat?.entityLink?.type || '').toLowerCase().includes('task')) {
            Tasks.dialogTaskById.set(dialogId, entityId);
            return entityId;
        }

        return 0;
    }

    static resolveTaskUrlFromDialog(dialogId) {
        const chat = Tasks.getChatByDialogId(dialogId);
        return chat?.entityLink?.url || '';
    }

    static resolveTaskIdFromUrl(url) {
        const preparedUrl = String(url || '');
        const taskMatches = preparedUrl.match(/\/tasks\/task\/(?:view|edit)\/(\d+)\//i);
        if (taskMatches && taskMatches[1]) {
            return parseInt(taskMatches[1], 10) || 0;
        }

        const queryMatches = preparedUrl.match(/[?&](?:taskId|TASK_ID)=(\d+)/);
        if (queryMatches && queryMatches[1]) {
            return parseInt(queryMatches[1], 10) || 0;
        }

        return 0;
    }

    static resolveGroupIdFromTaskUrl(url) {
        const groupMatches = String(url || '').match(/\/workgroups\/group\/(\d+)\//i);
        if (groupMatches && groupMatches[1]) {
            return parseInt(groupMatches[1], 10) || 0;
        }

        return 0;
    }

    static resolveUrlFromEventArgs(args) {
        if (args && args[1] && typeof args[1].url === 'string') {
            return args[1].url;
        }

        if (args && args['1'] && typeof args['1'].url === 'string') {
            return args['1'].url;
        }

        for (let i = 0; i < args.length; i++) {
            const arg = args[i];
            if (arg && typeof arg === 'object' && typeof arg.url === 'string') {
                return arg.url;
            }
        }

        return '';
    }

    static normalizeUrl(url) {
        if (typeof url !== 'string' || url.length === 0) {
            return '';
        }

        try {
            const parsedUrl = new URL(url, window.location.origin);
            return parsedUrl.pathname + parsedUrl.search;
        } catch (error) {
            return url;
        }
    }

    /**
     * Extract user ID from href
     * 
     * @param {string} href Link URL
     * @returns {string|null} User ID
     */
    static extractUserIdFromHref(href) {
        // Search for ID in format /company/personal/user/1/
        const match = href.match(/\/company\/personal\/user\/(\d+)/);
        return match ? match[1] : null;
    }

    /**
     * Extract comment ID from href
     * 
     * @param {string} href Link URL
     * @returns {string|null} Comment ID
     */
    static extractCommentIdFromHref(href) {
        const match = href.match(/MID=(\d+)/);
        return match ? match[1] : null;
    }


}

const RestrictedTaskCommentsMessageMenu = subClassEs6(
    TaskCommentsMessageMenu,
    Object.assign({}, getFullCardTaskCommentsMenuMethods(), {
    getTaskId() {
        const dialogId = this.context?.dialogId || '';
        return Tasks.resolveTaskIdFromDialog(dialogId)
            || Tasks.resolveTaskIdFromUrl(Tasks.resolveTaskUrlFromDialog(dialogId))
            || 0;
        },

    getEditItem() {
        return null;
        },

    getDeleteItem() {
        return null;
        },
    }),
);
